/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.0.1
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BulkRequestQuery } from "./BulkRequestQuery";
import {
  BulkRequestQueryFromJSON,
  BulkRequestQueryFromJSONTyped,
  BulkRequestQueryToJSON,
  BulkRequestQueryToJSONTyped,
} from "./BulkRequestQuery";

/**
 *
 * @export
 * @interface BulkRequest
 */
export interface BulkRequest {
  /**
   *
   * @type {string}
   * @memberof BulkRequest
   */
  endpoint?: BulkRequestEndpointEnum;
  /**
   *
   * @type {BulkRequestQuery}
   * @memberof BulkRequest
   */
  query?: BulkRequestQuery;
}

/**
 * @export
 */
export const BulkRequestEndpointEnum = {
  V1Search: "/v1/search",
  V1SearchStructured: "/v1/search/structured",
} as const;
export type BulkRequestEndpointEnum =
  (typeof BulkRequestEndpointEnum)[keyof typeof BulkRequestEndpointEnum];

/**
 * Check if a given object implements the BulkRequest interface.
 */
export function instanceOfBulkRequest(value: object): value is BulkRequest {
  return true;
}

export function BulkRequestFromJSON(json: any): BulkRequest {
  return BulkRequestFromJSONTyped(json, false);
}

export function BulkRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BulkRequest {
  if (json == null) {
    return json;
  }
  return {
    endpoint: json["endpoint"] == null ? undefined : json["endpoint"],
    query:
      json["query"] == null
        ? undefined
        : BulkRequestQueryFromJSON(json["query"]),
  };
}

export function BulkRequestToJSON(json: any): BulkRequest {
  return BulkRequestToJSONTyped(json, false);
}

export function BulkRequestToJSONTyped(
  value?: BulkRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    endpoint: value["endpoint"],
    query: BulkRequestQueryToJSON(value["query"]),
  };
}
